<template>
  <div class="range-container">
    <h2>{{start}} <span>-</span> {{end}}</h2>
    <b-container>
      <b-row>
        <b-col cols="1" class="text-right p-0 m-auto">
          0
        </b-col>
        <b-col cols="8" class="m-auto">
          <div>
            <b-progress :max="100">
              <b-progress-bar :value="start" variant="white"></b-progress-bar>
              <b-progress-bar :value="(end - start)" class="progress-slider" :style="{backgroundColor: color}"></b-progress-bar>
              <b-progress-bar :value="(100 - end)" variant="white"></b-progress-bar>
            </b-progress>
          </div>
        </b-col>
        <b-col cols="1" class="m-auto p-0 text-left">
          100
        </b-col>
        <b-col cols="2">
          <div :id="'popColorPick-'+start" @click="focusPicker" class="selected-color" :style="{backgroundColor: dataColor}" >
            <b-popover :target="'popColorPick-'+start"  triggers="click blur">
              <ColorPicker @colorSelected="setColor" ref="colorpicker" />
            </b-popover>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ColorPicker from '../../components/utils/ColorPicker'

export default {
  props: {
    start: Number,
    end: Number,
    color: String
  },
  data () {
    return {
      dataColor: this.color
    }
  },
  components: {
    ColorPicker
  },
  watch: {
    color: function () {
      this.dataColor = this.color
    }
  },
  methods: {
    setColor (color) {
      this.dataColor = color
      this.$emit('colorSelected', this.dataColor)
    },
    focusPicker () {
      this.$nextTick(() => {
        this.$refs.colorpicker.$el.focus()
      })
    }
  }
}
</script>

<style scoped>
.range-container {
  padding: 1rem 0;
  margin: 0.7rem 0.3rem;
  background-color: #f7f7f7;
}

h2 {
  text-align: center;
  font-size: 1.2rem;
}

h2 span {
  padding: 0 1rem;
}

.selected-color {
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/range.vue